import React from "react";
import {Card, CardContent, List, ListItem, Button} from "framework7-react";
import {useTranslation} from "react-i18next";

type TicketSectionProps = {
    title: string;
    description: string;
    items: any[];
    visibleCount: number;
    setVisibleCount: (value: React.SetStateAction<number>) => void;
    onTicketClick: (item: any, ticketType: string) => void;
    ticketType: string;
    link?: string;
};

export const TicketSection: React.FC<TicketSectionProps> = ({
                                                                title,
                                                                description,
    ticketType,
                                                                items,
                                                                visibleCount,
                                                                setVisibleCount,
                                                                onTicketClick, // передаємо функцію на клік
                                                                link,
                                                            }) => {
    const { t } = useTranslation();

    if (!items.length) return null;

    const showMoreVisible = items.length > visibleCount;
    const showLessVisible = visibleCount > 5;
    const buttonsCount = [showMoreVisible, showLessVisible].filter(Boolean).length;

    return (
        <Card>
            <CardContent>
                <List dividersIos mediaList outlineIos strongIos outline inset>
                    <ListItem
                        title={t(title)}
                        text={t(description)}
                    />

                    {items.slice(0, visibleCount).map((item, index) => (
                        <ListItem
                            key={item.id || index}
                            link="#"
                            title={item.title}
                            subtitle={item.preview_title}
                            text={item.description}
                            onClick={() => onTicketClick(item, ticketType)}
                        >
                            <img
                                alt="logo"
                                slot="media"
                                style={{ borderRadius: '8px' }}
                                src={item.preview_img}
                                width="50"
                            />
                        </ListItem>
                    ))}

                    {items.length > 5 && (
                        <ListItem>
                            <div className={`grid grid-gap ${buttonsCount === 1 ? 'grid-cols-1' : 'grid-cols-2'}`}>
                                {showMoreVisible && (
                                    <Button
                                        large
                                        fill
                                        onClick={() => setVisibleCount(prev => prev + 5)}
                                    >
                                        {t("btn.showMore")}
                                    </Button>
                                )}
                                {showLessVisible && (
                                    <Button
                                        large
                                        fill
                                        onClick={() => setVisibleCount(prev => prev - 5)}
                                    >
                                        {t("btn.showLess")}
                                    </Button>
                                )}
                            </div>
                        </ListItem>
                    )}
                </List>
            </CardContent>
        </Card>
    );
};

